export default __webpack_public_path__ + "static/preview-987360565d8fe7838b39b99dff272d2f.jpg";